import DZModelPage from "@/model/DZModelPage";

class DZSearchUser extends DZModelPage{

    /**
     * 手机号
     */
    phone = '';
    /**
     * 邮箱
     */
    email = '';
    /**
     * 微信号
     */
    wxNum = '';

    /**
     * 审核状态：99-正常，-1-禁用
     */
    status = '';

}
export default DZSearchUser
